import React, { useState } from 'react';
import "@assets/css/Services.css";
import Compare from '../../components/Compare';
import Referenskort, { formatYears } from '../../components/Referenskort/Referenskort';

// Projektdata - flytta gärna till en egen data-fil om listan växer
//
// years: [2019, 2020, 2023]  -> array med årtal, ett eller flera
// Sortering: projekten visas efter senaste angivna året i "years"
// (nyast överst). Lägger du till ett nytt, senare år på ett befintligt
// projekt flyttas det automatiskt upp till rätt plats - ingen manuell
// omflyttning behövs.
const projects = [
  {
    id: 1,
    title: 'ERIC AMARILLO',
    years: [2013],
    topic: 'Ljus, Truss',
    des: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ut sequi, rem magnam nesciunt minima placeat, itaque eum neque officiis unde.',
    img: './images/image/img1.jpg',
    // Lägg till fler bilder här när ni har dem, t.ex.:
    // gallery: ['./images/image/img1.jpg', './images/image/img1b.jpg', './images/image/img1c.jpg'],
  },
  {
    id: 2,
    title: 'QUARNEVALEN ÖLTÄLTET',
    years: [],
    topic: 'Scen, Ljud, Ljus, Tekniker',
    des: '',
    img: './images/image/img2.jpg',
  },
  {
    id: 3,
    title: 'SQUVALP SLUTFEST',
    years: [],
    topic: 'Ljud, Ljus, Rigg, Tekniker',
    des: '',
    img: './images/image/img3.jpg',
  },
  {
    id: 4,
    title: 'SYSTER SOL',
    years: [2023],
    topic: 'Scen, Ljud, Ljus, Tekniker',
    des: '',
    img: './images/image/img4.jpg',
  },
  {
    id: 5,
    title: 'NT-SHOWEN',
    years: [2022],
    topic: 'Ljud, Ljus, Video, Tekniker',
    des: '',
    img: './images/image/img5.jpg',
  },
  {
    id: 6,
    title: 'GUSTAVSBERGS KYRKA',
    years: [2025],
    topic: 'Ljus, Tekniker',
    des: 'Kören och kyrkan önskade ljusättning av deras konsert. Vi hjälpte till med belysning och tekniker, bland annat American DJ 32 Hex Panels, Stairville LED Bar 16 Pro och Varytec Hero Wash 300 FC som frontljus till kören.',
    img: './images/image/img7.jpg',
  },
  {
    id: 7,
    title: 'Happy Sally, Eriksdalsbadet',
    years: [2009],
    topic: 'Ljud',
    des: 'Happy Sally sattes upp som en teaterföreställning på Eriksdalsbadet i Stockhom. Text: Sara Stridsberg. Regi: Saga Gärde. Scenografi: Jovanna Remaeus. Musik: Tobias Lilja. Medv: Cecilia Häll, Regina Lund, Magnus Krepper m fl. Vi levererade ljudutrustningen. 4 st mindre Line array hängdes i en truss ovanför bassängen för att förstärka skådespelarna och spela upp inspelat ljud, högtalare placerades på motsatt sida av bassängen för att få bland annat miljöljud. Vi levererade även trådlösa mikrofonsystem och myggor som klarade av att vara i vattnet.',
    img: './images/image/happysally.jpg',
    gallery: ['./images/image/happysally.jpg', './images/image/happysally_2.jpg'],
  },
  {
    id: 8,
    title: 'Bygge av Tvärbanan, Stockholm',
    years: [2011],
    topic: 'Truss',
    des: 'När tvärbanan skulle byggas vid Alvik byggde vi Ground Support över ett byggschakt för att kunna hissa ner ventilationstrummor och fläktar i schaktet. Lösningen var att med hjälp av ett sleeveblock lyfta trummor och fläktar vid sidan av det djupa hålet och sedan dra sleeveblocket ut över hålet för att sedan hissa ner trummorna och fläktarna för att kunna monteras.',
    img: './images/image/tvarbanan.jpg',
  },
  {
    id: 9,
    title: 'School´s Out, Sollentuna',
    years: [2023, 2024, 2025, 2026],
    topic: 'Truss, Ground Support',
    des: 'School´s Out Festival är Sveriges största ungdomsfest för ungdomar mellan 13-17år. 3200 ungdomar får en fantastisk sommarfestival! Festivalområdet utanför Arena Satelliten förvandlas till ett magiskt Hawaii-inspirerat paradis i orange, rött och gult, med palmer, blommor och mysig belysning. Vi levererar Ground Support till scenen, vi har tillverkat specialdelar, specialbyggda outriggers för att kunna bygga ground supporten i en trappa.',
    img: './images/image/schoolsout.jpg',
    gallery: ['./images/image/schoolsout.jpg', './images/image/schoolsout_2.jpg', './images/image/schoolsout_3.jpg'],
  },
  {
    id: 10,
    title: 'Valborg, Sollentuna',
    years: [2023, 2024, 2025, 2026],
    topic: 'Ljud, Tekniker',
    des: '',
    img: './images/image/valborg.jpg',
    gallery: ['./images/image/valborg.jpg'],
  },
];

// Sorterar en kopia av listan efter det senaste årtalet i "years"
// (om ett projekt har flera år används det högsta). Projekt utan
// angivet år hamnar sist. Vid samma senaste år avgör id (högst id vinner).
function latestYear(project) {
  return project.years?.length > 0 ? Math.max(...project.years) : -Infinity;
}

const sortedProjects = [...projects].sort(
  (a, b) => latestYear(b) - latestYear(a) || b.id - a.id
);

// Klipper av en text vid ordgräns och lägger till ett mellanslag + "..."
// om den är längre än maxLength. Används för hover-beskrivningen på korten
// - hela texten visas fortfarande oavkortad i popupen (Referenskortet).
function truncate(text, maxLength = 150) {
  if (!text || text.length <= maxLength) return text;
  const cut = text.slice(0, maxLength);
  const lastSpace = cut.lastIndexOf(' ');
  return `${cut.slice(0, lastSpace > 0 ? lastSpace : maxLength)} ...`;
}

function Services() {
  const [activeProject, setActiveProject] = useState(null);
  const [originPoint, setOriginPoint] = useState(null);

  function handleOpen(project, e) {
    // Sparar klickpositionen så popupen kan "zooma upp" därifrån
    setOriginPoint({ x: e.clientX, y: e.clientY });
    setActiveProject(project);
  }

  function handleClose() {
    setActiveProject(null);
    setOriginPoint(null);
  }

  return (
    <>
      <div className="services-container">
        <Compare />

        <section className="portfolio-section">
          <div className="portfolio-header">
            <h2 className="portfolio-title">Ett urval av våra produktioner</h2>
            <p className="portfolio-subtitle">Stora som små</p>
          </div>

          <div className="portfolio-grid">
            {sortedProjects.map((project) => (
              <article
                className="portfolio-card"
                key={project.id}
                onClick={(e) => handleOpen(project, e)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') handleOpen(project, e);
                }}
              >
                <div className="portfolio-card-image">
                  <img src={project.img} alt={project.title} loading="lazy" />
                  <div className="portfolio-card-overlay">
                    <p className="portfolio-card-des">{truncate(project.des)}</p>
                  </div>
                </div>
                <div className="portfolio-card-body">
                  <h3 className="portfolio-card-title">{project.title}</h3>
                  <div className="portfolio-card-meta">
                    <span className="portfolio-card-topic">{project.topic}</span>
                    {project.years?.length > 0 && (
                      <span className="portfolio-card-year">
                        {formatYears(project.years)}
                      </span>
                    )}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>
      </div>

      {activeProject && (
        <Referenskort
          project={activeProject}
          onClose={handleClose}
          originPoint={originPoint}
        />
      )}
    </>
  );
}

export default Services;
